import { Link } from "@inertiajs/react";

const Breadcrumb = ({ pageName, pageLink, pageLinkName, showTitle = true }) => {
    return (
        <div
            className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-center ${
                showTitle ? "sm:justify-between" : "sm:justify-end"
            }`}
        >
            {showTitle ? (
                <h2 className="text-title-md2 font-semibold text-black dark:text-white">
                    {pageName}
                </h2>
            ) : null}

            <nav>
                <ol className="flex items-center gap-2">
                    <li>
                        <Link className="font-medium" href={pageLink}>
                            {pageLinkName} /
                        </Link>
                    </li>
                    <li className="font-medium text-primary">{pageName}</li>
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumb;
